/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractActionV1Dto } from '../models/ContractActionV1Dto';
import type { CreateContractActionV1Dto } from '../models/CreateContractActionV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchContractActionStatusV1Dto } from '../models/PatchContractActionStatusV1Dto';
import type { PatchContractActionV1Dto } from '../models/PatchContractActionV1Dto';
import type { PatchPositionsListV1Dto } from '../models/PatchPositionsListV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContractActionsService {
  /**
   * @param requestBody
   * @returns ContractActionV1Dto create entity
   * @throws ApiError
   */
  public static contractActionControllerV1CreateV1(
    requestBody: CreateContractActionV1Dto,
  ): CancelablePromise<ContractActionV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contract-actions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ContractActionV1Dto a entity list
   * @throws ApiError
   */
  public static contractActionControllerV1FindAllV1(): CancelablePromise<
    Array<ContractActionV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contract-actions',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contractActionControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contract-actions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid contractActionId
   * @returns ContractActionV1Dto the entity
   * @throws ApiError
   */
  public static contractActionControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<ContractActionV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contract-actions/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contractActionId
   * @param requestBody
   * @returns ContractActionV1Dto the update entity
   * @throws ApiError
   */
  public static contractActionControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchContractActionV1Dto,
  ): CancelablePromise<ContractActionV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contract-actions/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid contractActionId
   * @returns ContractActionV1Dto the entity
   * @throws ApiError
   */
  public static contractActionControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<ContractActionV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contract-actions/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param contractId contractId
   * @returns ContractActionV1Dto a entity list
   * @throws ApiError
   */
  public static contractActionControllerV1FindManyByContractIdV1(
    contractId: string,
  ): CancelablePromise<Array<ContractActionV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contract-actions/contract/{contractId}',
      path: {
        contractId: contractId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param contractId contractId
   * @param requestBody
   * @returns ContractActionV1Dto the update entity
   * @throws ApiError
   */
  public static contractActionControllerV1UpdatePositionsV1(
    contractId: string,
    requestBody: PatchPositionsListV1Dto,
  ): CancelablePromise<ContractActionV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contract-actions/contract/{contractId}/positions',
      path: {
        contractId: contractId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid contractActionId
   * @param requestBody
   * @returns ContractActionV1Dto the update entity
   * @throws ApiError
   */
  public static contractActionControllerV1UpdatePartialStatusV1(
    uuid: string,
    requestBody: PatchContractActionStatusV1Dto,
  ): CancelablePromise<ContractActionV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contract-actions/{uuid}/status',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
